<template>
  <div>
    <van-field
      readonly
      clickable
      label="城市"
      :value="value"
      placeholder="选择城市"
      @click="showPicker = true"
      input-align="right"
    />
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Picker,
  Field,
  Popup
} from 'vant'
import city from "@utils/cityCode.json"
function getChildren(data) {
  return data.forEach(v => {
    if (v.children && v.children.length) {
      v.text = v.name
      delete v.name
      return getChildren(v.children)
    } else {
      v.text = v.name
      delete v.name
      return v
    }
  })

}
getChildren(city)
// console.log(JSON.stringify(city))
export default {
  data () {
    return {
      value: '',
      showPicker: false,
      columns: city
    }
  },
  methods: {
    onConfirm (value) {
      this.value = value
      this.showPicker = false
    }
  },
  components: {
    [Picker.name]: Picker,
    [Field.name]: Field,
    [Popup.name]: Popup
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
